// @ts-nocheck
import type { TridentCampaignDetails } from 'types/trident-campaigns';
import { targetUserTypes } from 'data/trident-types';
import React, { Component } from 'react';
import _ from 'lodash';
import i18n from 'i18n-js';

import FormInputWithError from 'components/form/FormInputWithError';
import { Form, Grid, Icon, Label } from 'semantic-grab-ui/src';
import LocalizedMenu from 'components/form/LocalizedMenu';
import formComponent from 'components/decorators/form_component';
import { DEFAULT_LOCALE } from 'config';
import CDropdown from '../../custom/CDropdown';

interface Props {
  model: TridentCampaignDetails;
  currentNode: string;
  subActionIndex: number;
  onModelChange: (model?: Object) => void;
  handleInputChange: Function;
  handleControlBlur: Function;
  error: Object;
}

interface State {
  isLangSelectOpen: boolean;
}

// TODO: move the options to ucm
const BACKGROUND_COLOR_OPTIONS = [
  {
    key: '#EBFAFF',
    text: 'Informative',
    value: '#EBFAFF',
  },
  {
    key: '#D9FCDE',
    text: 'Positive',
    value: '#D9FCDE',
  },
  {
    key: '#FFF9C0',
    text: 'Notice',
    value: '#FFF9C0',
  },
  {
    key: '#FDF2F2',
    text: 'Alert',
    value: '#FDF2F2',
  },
];

const DEFAULT_BACKGROUND_COLOR = '#EBFAFF';

const INAPP_NOTIF_OPTIONS = [
  {
    key: 'INAPP_HEADS_UP',
    text: 'Heads up',
    value: 'INAPP_HEADS_UP',
  },
  {
    key: 'INAPP_BOTTOM_SHEET',
    text: 'Bottom sheet',
    value: 'INAPP_BOTTOM_SHEET',
  },
];
const DEFAULT_INAPP_NOTIF = 'INAPP_HEADS_UP';

const PUSH_NOTIF_OPTIONS = [
  {
    key: 'true',
    text: 'Disable',
    value: true, // the meta param is 'disablePush', so 'disable' maps to true
  },
  {
    key: 'false',
    text: 'Enable',
    value: false,
  },
];

const DEFAULT_DISABLE_PUSH_NOTIF = false;

const RECIPIENT_OPTIONS = {
  all: {
    key: 'all',
    value: 'all',
    text: 'All participants',
  },
  pax: {
    key: 'pax',
    value: 'pax',
    text: 'Pax only',
  },
  dax: {
    key: 'dax',
    value: 'dax',
    text: 'Dax only',
  },
};

@formComponent()
export default class ActionSendGrabChat extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isLangSelectOpen: false,
    };
  }

  isTargetUserPax = (): boolean => {
    const { model } = this.props;
    const targetUserType = _.get(model, 'targetUserType', '');
    return targetUserType === targetUserTypes.pax || targetUserType === targetUserTypes.moveITPax;
  }

  getAddedLanguages = (): string[] => {
    const { model, currentNode, subActionIndex } = this.props;
    const grabchatPayloads = _.get(model.nodes[currentNode], `data[${subActionIndex}].meta.grabchatPayload`, {});
    const grabchatPayloadContent = grabchatPayloads.content || {};

    return _.union(
      [DEFAULT_LOCALE], // keep default to be the first.
      _.keys(grabchatPayloadContent)
    );
  }

  handleUpdateLanguages = (langs: string[]): void => {
    const currentLangs = this.getAddedLanguages();
    const toAddLangs = _.filter(langs, (v) => { return currentLangs.indexOf(v) === -1; });
    const toRemoveLangs = _.filter(currentLangs, (v) => { return langs.indexOf(v) === -1; });

    const updatedModel = { ...this.props.model };
    toAddLangs.forEach((lang) => {
      _.set(updatedModel.nodes[this.props.currentNode], `data[${this.props.subActionIndex}].meta.grabchatPayload.content.${lang}`, '');
    });
    toRemoveLangs.forEach((lang) => {
      _.unset(updatedModel.nodes[this.props.currentNode], `data[${this.props.subActionIndex}].meta.grabchatPayload.content.${lang}`);
    });

    this.props.onModelChange(updatedModel);
  }

  renderMenuIcons(): any {
    return _.reduce(this.props.error, (icons, error, language) => {
      if (!error.allFieldsDirty) {
        return Object.assign({}, icons, { [language]: null });
      }

      const icon = !error.totalError
        ? <Icon name="check circle" color="green" size="large" />
        : <Label color="red">{error.totalError}</Label>;
      return Object.assign({}, icons, { [language]: icon });
    }, {});
  }

  handleTabClick = (tab: string) => {
    console.log('Tab clicked:', tab);
  };

  validateHtmlTags = (htmlContent: string): { isValid: boolean; invalidTag?: string } => {
    const allowedTags = ['b', 'strong', 'i', 'span', 'br', 'a', 'p'];
    
    // Regular expression to match all HTML tags
    const tagRegex = /<\/?([a-zA-Z][a-zA-Z0-9]*)\b[^>]*>/g;
    const matches = htmlContent.match(tagRegex);
    
    if (!matches) {
      return { isValid: true };
    }
    
    for (const match of matches) {
      // Extract tag name from the match
      const tagMatch = match.match(/<\/?([a-zA-Z][a-zA-Z0-9]*)/);
      if (tagMatch) {
        const tagName = tagMatch[1].toLowerCase();
        if (!allowedTags.includes(tagName)) {
          return { isValid: false, invalidTag: tagName };
        }
      }
    }
    
    return { isValid: true };
  };

  render() {
    const { model, currentNode, subActionIndex } = this.props;
    const grabchatPayloads = _.get(model.nodes[currentNode], `data[${subActionIndex}].meta.grabchatPayload`, {});
    const grabchatPayloadContent = grabchatPayloads.content || {};
    const backgroundColor = _.get(model.nodes[currentNode], `data[${subActionIndex}].meta.grabchatPayload.backgroundColor`, DEFAULT_BACKGROUND_COLOR);

    const addedLangs = this.getAddedLanguages();

    const localizedContents = _.reduce(addedLangs, (result, language) => {
      const htmlContent = grabchatPayloadContent[language] || '';
      const validation = this.validateHtmlTags(htmlContent);
      
      const content = (
        <div>
          <FormInputWithError
            name={`nodes.${currentNode}.data.${subActionIndex}.meta.grabchatPayload.content.${language}`}
            {...this.props}
          >
            <Form.TextArea
              label="Content (HTML)"
              value={htmlContent}
              onChange={this.props.handleInputChange}
              onBlur={this.props.handleControlBlur}
            />
          </FormInputWithError>
          
          {htmlContent.trim() && (
            <div style={{ marginTop: '15px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '8px', 
                fontWeight: 'bold',
                fontSize: '14px',
                color: '#333'
              }}>
                Preview
              </label>
              <div style={{ 
                border: '1px solid #ddd', 
                borderRadius: '4px',
                backgroundColor: '#f9f9f9',
                padding: '12px'
              }}>
                {!validation.isValid ? (
                  <div style={{
                    color: '#d32f2f',
                    backgroundColor: '#ffebee',
                    padding: '12px',
                    borderRadius: '4px',
                    border: '1px solid #ffcdd2',
                    fontSize: '14px'
                  }}>
                    <Icon name="exclamation triangle" style={{ marginRight: '8px' }} />
                    <strong>&lt;{validation.invalidTag}&gt;</strong> tag is not supported<br/>
                    Please check out the <a href="https://grabtaxi.atlassian.net/wiki/spaces/RTC/pages/122556262/Chat+Message+-+Content+Types#HTML-Support" target="_blank">wiki</a> for the details on HTML support.
                  </div>
                ) : (
                  <iframe
                    srcDoc={`
                      <html>
                        <head>
                          <style>
                            body {
                              margin: 0;
                              padding: 20px;
                              font-family: Arial, sans-serif;
                              background-color: #f5f5f5;
                            }
                            .chat-message {
                              background-color: ${backgroundColor};
                              padding: 15px 20px;
                              border-radius: 12px;
                              margin: 0 auto;
                              box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                              word-wrap: break-word;
                            }
                          </style>
                        </head>
                        <body>
                          <div class="chat-message">
                            ${htmlContent}
                          </div>
                        </body>
                      </html>
                    `}
                    style={{
                      width: '100%',
                      height: '200px',
                      border: 'none',
                      borderRadius: '2px',
                      backgroundColor: 'white'
                    }}
                    title={`HTML Preview - ${language}`}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      );

      return Object.assign({}, result, { [language]: content });
    }, {});

    // build recipient options
    const recipientOptions = [RECIPIENT_OPTIONS.all];
    if (this.isTargetUserPax()) {
      recipientOptions.push(RECIPIENT_OPTIONS.pax);
    } else {
      recipientOptions.push(RECIPIENT_OPTIONS.dax);
    }
    const defaultRecipient = this.isTargetUserPax() ? 'pax' : 'dax';

    // change textbox color when background changes

    return (
      <Form>
        <Grid>
          <Grid.Column width={14}>
            <LocalizedMenu
              languages={addedLangs}
              contents={localizedContents}
              icons={this.renderMenuIcons()}
              showAddLanguage
              onUpdateLanguages={this.handleUpdateLanguages}
              onTabClick={this.handleTabClick}
            />
          </Grid.Column>

          <Grid.Row>
            <Grid.Column width={6}>
              <FormInputWithError
                name={`nodes.${currentNode}.data.${subActionIndex}.meta.grabchatPayload.backgroundColor`}
                {...this.props}
              >
                <CDropdown
                  required
                  label="Background Color"
                  options={BACKGROUND_COLOR_OPTIONS}
                  value={backgroundColor}
                  onChange={this.props.handleInputChange}
                  onBlur={this.props.handleControlBlur}
                  style={{ backgroundColor: backgroundColor}}
                />
              </FormInputWithError>
            </Grid.Column>

            <Grid.Column width={6}>
              <FormInputWithError
                name={`nodes.${currentNode}.data.${subActionIndex}.meta.grabchatPayload.recipients`}
                {...this.props}
              >
                <CDropdown
                  required
                  label="Recipient"
                  options={recipientOptions}
                  value={_.get(
                    model.nodes[currentNode],
                    `data.${subActionIndex}.meta.grabchatPayload.recipients`,
                    defaultRecipient,
                  )}
                  onChange={this.props.handleInputChange}
                  onBlur={this.props.handleControlBlur}
                />
              </FormInputWithError>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={6}>
              <FormInputWithError
                name={`nodes.${currentNode}.data.${subActionIndex}.meta.grabchatPayload.disablePush`}
                {...this.props}
              >
                <CDropdown
                  required
                  label="Push Notification"
                  options={PUSH_NOTIF_OPTIONS}
                  value={_.get(
                    model.nodes[currentNode],
                    `data.${subActionIndex}.meta.grabchatPayload.disablePush`,
                    DEFAULT_DISABLE_PUSH_NOTIF,
                  )}
                  onChange={this.props.handleInputChange}
                  onBlur={this.props.handleControlBlur}
                />
              </FormInputWithError>
            </Grid.Column>

            <Grid.Column width={6}>
              <FormInputWithError
                name={`nodes.${currentNode}.data.${subActionIndex}.meta.grabchatPayload.inAppNotifStyle`}
                {...this.props}
              >
                <CDropdown
                  required
                  label="In-App Notification"
                  options={INAPP_NOTIF_OPTIONS}
                  value={_.get(
                    model.nodes[currentNode],
                    `data.${subActionIndex}.meta.grabchatPayload.inAppNotifStyle`,
                    DEFAULT_INAPP_NOTIF,
                  )}
                  onChange={this.props.handleInputChange}
                  onBlur={this.props.handleControlBlur}
                />
              </FormInputWithError>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}
